import { render } from "./Finances.vue?vue&type=template&id=b7bb51d0&scoped=true"
import script from "./Finances.vue?vue&type=script&lang=js"
export * from "./Finances.vue?vue&type=script&lang=js"

import "./Finances.vue?vue&type=style&index=0&id=b7bb51d0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bb51d0"]])

export default __exports__